/**
 * محاسبه متن کوئری مربوط به موضوع ساز ساده
 * مثال:
 * (money + cash) * (payment * online) * (!dollar * !euro)
 */
const calculateParsedQuery = (lists, conjunction = ' + ', prefix = '') => {
  if (prefix) lists = lists.map((item) => prefix + item);
  return `(${lists.join(conjunction)})`;
};

export const calculateSimpleParsedQuery = (
  contain = [],
  mustContain = [],
  mustNotContain = []
) => {
  let parsedQuery = '';
  let containSection = '';
  let mustContainSection = '';
  let mustNotContainSection = '';

  if (contain.length > 0) {
    containSection = calculateParsedQuery(contain);
  }

  if (mustContain.length > 0) {
    mustContainSection = calculateParsedQuery(mustContain, ' * ');
  }

  if (mustNotContain.length > 0) {
    mustNotContainSection = calculateParsedQuery(mustNotContain, ' * ', '!');
  }

  if (containSection && mustContainSection) {
    parsedQuery = `${containSection} * ${mustContainSection}`;
  } else if (containSection) {
    parsedQuery = containSection;
  } else if (mustContainSection) {
    parsedQuery = mustContainSection;
  }

  if ((containSection || mustContainSection) && mustNotContainSection)
    parsedQuery += ` * ${mustNotContainSection}`;
  else if (mustNotContainSection) parsedQuery = mustNotContainSection;

  return parsedQuery;
};
